export const boltaev = {
    id: "boltaev",
    name: { ru: "Болтаев Олжас", kz: "Болтаев Олжас" },
    position: { ru: "Врач спортивной медицины", kz: "Спорттық медицина дәрігері" },
    department: "medical-staff",
    image: "/team_photoes/new/Болтаев Олжас.svg",
    experience: {
      ru: "8 лет 9 месяцев",
      kz: "8 жыл 9 ай"
    },
    education: {
      ru: `2016–2018 —  Казахский Национальный Медицинский Университет имени С.Д. Асфендиярова, специальность «Врач спортивной медицины»\n2014–2016 —  Казахский Национальный Медицинский Университет имени С.Д. Асфендиярова, специальность «Врач общей хирургии»\n2009–2014 —  Казахский Национальный Медицинский Университет имени С.Д. Асфендиярова, специальность «Врач общей медицины»`,
      kz: `2016–2018 —  С.Ж. Асфендияров атындағы Қазақ ұлттық медицина университеті, «Спорттық медицина дәрігері» мамандығы
2014–2016 —  С.Ж. Асфендияров атындағы Қазақ ұлттық медицина университеті, «Жалпы хирургия» мамандығы
2009–2014 —  С.Ж. Асфендияров атындағы Қазақ ұлттық медицина университеті, «Жалпы медицина» мамандығы`
    },
    specialization: {
      ru: `• Медосмотры и оценка физической готовности
• Профилактика травм
• Индивидуальные тренировочные рекомендации
• Восстановление и информирование спортсменов`,
      kz: `• Медициналық тексерулер және дене дайындығын бағалау
• Жарақаттанудың алдын алу
• Жеке жаттығулар бойынша ұсыныстар
• Спортшыларды қалпына келтіру және ақпараттандыру`
    },
        work: {
    ru: `• 2018 — 2020 — РГУ «РСШИ колледж олимпийского резерва», Алматы, Медицинское наблюдение и диспансеризация спортсменов
• 2021 — 2022 — АО «Национальный олимпийский комитет РК», Астана, Медико-биологическое сопровождение сборной
• 2022 — 2025 — РГП на ПХВ «Национальный центр спортивной медицины и реабилитации», Алматы, Спортивный врач сборной по шорт-треку
• 2025 — по настоящее время — ГККП «Спортивный медицинский центр», Астана, Врач спортивной медицины`,
    kz: `• 2018 — 2020 — «Олимпиада резервінің республикалық мамандандырылған мектеп-интернат-колледжі» РММ, Алматы қ., спортшыларды медициналық бақылау және диспансерлеу
• 2021 — 2022 — «ҚР Ұлттық Олимпиадалық комитеті» АҚ, Астана қ., құраманы медициналық-биологиялық қамтамасыз ету
• 2022 — 2025 — «Спорттық медицина және оңалту ұлттық орталығы» ШЖҚ РМК, Алматы қ., шорт-трек бойынша ұлттық құраманың спорт дәрігері
• 2025 — қазіргі уақытқа дейін — Астана қаласының «Спорттық медицина орталығы» МКҚК, спорттық медицина дәрігері`
  },
certificates: {
    ru: `Повышение квалификации:
• Data Analytics, Academica Courses, 2025`,
    kz: `Біліктілікті арттыру:
• Data Analytics, Academica Courses, 2025`,
  }
  };
